export default __webpack_public_path__ + "building-front.png";